export type SessionState = {
  token: string | null;
};

export const initialSessionState: SessionState = {
  token: null,
};
